import {Dispatch} from 'redux';
import {ErrorDto} from '../../../models/dtos/error.dto';
import {Errors} from '../../../utilities/errors';
import {VALIDATE_OTP_START, VALIDATE_OTP_SUCCESS, VALIDATE_OTP_FAIL, VALIDATE_OTP_RESET} from './constants';
import {ValidateOtpStartAction, ValidateOtpSuccessAction, ValidateOtpFailAction, ValidateOtpResetAction} from './types';
import {validateOtpRequest} from './repository';
import {ValidateOtpRequest} from '../../../models/requests/validateOtp.request';
import {AnswerDto} from '../../../models/dtos/answer.dto';

const validateOtpStartAction = (): ValidateOtpStartAction => {
  return {
    type: VALIDATE_OTP_START,
  };
};
const validateOtpSuccessAction = (payload: AnswerDto): ValidateOtpSuccessAction => {
  return {
    type: VALIDATE_OTP_SUCCESS,
    payload: payload,
  };
};
const validateOtpFailAction = (error: ErrorDto): ValidateOtpFailAction => {
  return {
    type: VALIDATE_OTP_FAIL,
    error: error,
  };
};
const validateOtpResetAction = (): ValidateOtpResetAction => {
  return {
    type: VALIDATE_OTP_RESET,
  };
};

export const validateOtp = (request: ValidateOtpRequest) => async (dispatch: Dispatch) => {
  try {
    dispatch(validateOtpStartAction());
    const response = await validateOtpRequest(request);
    dispatch(validateOtpSuccessAction(response));
  } catch (error) {
    dispatch(validateOtpFailAction(Errors.getErrorDtoFromApiError(error)));
  }
};

export const validateOtpReset = () => (dispatch: Dispatch) => {
  dispatch(validateOtpResetAction());
};
